import { Box, Card, CardContent, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { fmtDate, statusColor } from "../../../format";
import type { MaintenanceTicket } from "../../../types";

interface TicketsCardProps {
  loading: boolean;
  tickets: MaintenanceTicket[];
}

export function TicketsCard({ loading, tickets }: TicketsCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Maintenance Tickets</Typography>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        )}
        {!loading && tickets.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No maintenance tickets.
          </Typography>
        )}
        {!loading && tickets.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Charge Point</TableCell>
                <TableCell>Connector</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Error Code</TableCell>
                <TableCell>Source</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>First Seen</TableCell>
                <TableCell>Last Seen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets.map((ticket) => (
                <TableRow key={ticket.id}>
                  <TableCell sx={{ fontFamily: "monospace" }}>{ticket.charge_point_id}</TableCell>
                  <TableCell>{ticket.connector_id}</TableCell>
                  <TableCell>{ticket.title}</TableCell>
                  <TableCell>{ticket.error_code}</TableCell>
                  <TableCell>{ticket.source}</TableCell>
                  <TableCell>
                    <Chip label={ticket.status} color={statusColor(ticket.status)} size="small" />
                  </TableCell>
                  <TableCell>{fmtDate(ticket.first_seen_at)}</TableCell>
                  <TableCell>{fmtDate(ticket.last_seen_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
